/* ================================================
   MR. DERK CUSTOM SCRIPTS
   Stat counter animation + interactions
   ================================================ */

(function () {
  var animated = false;

  function animateNumbers() {
    if (animated) return;
    var section = document.getElementById('stats-section');
    if (!section) return;
    var rect = section.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.75) {
      animated = true;
      var numbers = section.querySelectorAll('.stat-number[data-target]');
      for (var i = 0; i < numbers.length; i++) {
        (function (el) {
          var target = parseInt(el.getAttribute('data-target'));
          var prefix = el.getAttribute('data-prefix') || '';
          var suffix = el.getAttribute('data-suffix') || '';
          var duration = target > 1000 ? 2000 : 1000;
          var steps = 60;
          var increment = target / steps;
          var current = 0;
          var timer = setInterval(function () {
            current += increment;
            if (current >= target) {
              current = target;
              clearInterval(timer);
            }
            el.textContent = prefix + Math.floor(current).toLocaleString() + suffix;
          }, duration / steps);
        })(numbers[i]);
      }
    }
  }

  window.addEventListener('scroll', animateNumbers);
  window.addEventListener('load', animateNumbers);
})();

/* ================================================
   SIZE CHART UNIT TOGGLE (CM / INCHES)
   ================================================ */

(function () {
  function initSizeChartToggles() {
    var toggles = document.querySelectorAll('.mrderk-unit-toggle');
    if (!toggles.length) return;

    for (var t = 0; t < toggles.length; t++) {
      (function (toggle) {
        var chart = toggle.closest('.mrderk-size-chart');
        if (!chart) return;

        var cmBtn = toggle.querySelector('[data-unit="cm"]');
        var inBtn = toggle.querySelector('[data-unit="in"]');
        if (!cmBtn || !inBtn) return;

        function setUnit(unit) {
          var cells = chart.querySelectorAll('[data-cm]');
          for (var i = 0; i < cells.length; i++) {
            var cm = parseFloat(cells[i].getAttribute('data-cm'));
            if (isNaN(cm)) continue;
            if (unit === 'in') {
              var inches = cm / 2.54;
              cells[i].textContent = inches % 1 === 0 ? inches.toFixed(0) : inches.toFixed(1);
            } else {
              cells[i].textContent = cm % 1 === 0 ? cm.toFixed(0) : cm;
            }
          }
          if (unit === 'cm') {
            cmBtn.style.background = '#231F20';
            cmBtn.style.color = '#FFFFFF';
            inBtn.style.background = '#FFFFFF';
            inBtn.style.color = '#231F20';
          } else {
            inBtn.style.background = '#231F20';
            inBtn.style.color = '#FFFFFF';
            cmBtn.style.background = '#FFFFFF';
            cmBtn.style.color = '#231F20';
          }
        }

        cmBtn.addEventListener('click', function () { setUnit('cm'); });
        inBtn.addEventListener('click', function () { setUnit('in'); });

        setUnit('in');
      })(toggles[t]);
    }
  }

  window.addEventListener('load', initSizeChartToggles);
  document.addEventListener('toggle', function (e) {
    if (e.target.tagName === 'DETAILS') {
      setTimeout(initSizeChartToggles, 50);
    }
  }, true);
})();

/* ================================================
   SALE BADGE - compute savings %, write to data-pct
   v2: walks up parents for strikethrough detection,
   handles Tailwind line-through applied to ancestors.
   ================================================ */

(function () {
  var priceRegex = /^\s*(CA)?\$[\d,]+\.?\d*\s*$/;

  function readPrice(el) {
    var text = el.textContent.trim();
    if (!priceRegex.test(text)) return null;
    return parseFloat(text.replace(/[^\d.]/g, ''));
  }

  function hasStrikethrough(el, stopAt) {
    var node = el;
    while (node && node !== stopAt && node.nodeType === 1) {
      var style = window.getComputedStyle(node);
      var dec = style.textDecorationLine || style.textDecoration || '';
      if (dec.indexOf('line-through') !== -1) return true;
      var cls = (node.className && node.className.baseVal) || node.className || '';
      if (typeof cls === 'string' && cls.indexOf('line-through') !== -1) return true;
      node = node.parentElement;
    }
    return false;
  }

  function setSavingsPct() {
    var saleEls = document.querySelectorAll('.bg-white.decoration-orange.underline');
    for (var i = 0; i < saleEls.length; i++) {
      var saleEl = saleEls[i];
      var card = saleEl.closest('.product-card__inner, .product-card');
      if (!card) continue;

      var compareVal = 0;
      var currentVal = 0;
      var allEls = card.querySelectorAll('*');

      for (var j = 0; j < allEls.length; j++) {
        var el = allEls[j];
        if (el.children.length > 0) continue;
        var val = readPrice(el);
        if (val === null) continue;
        if (hasStrikethrough(el, card)) {
          if (compareVal === 0 || val > compareVal) compareVal = val;
        } else if (currentVal === 0 || val < currentVal) {
          currentVal = val;
        }
      }

      // Only set data-pct when both prices are real (skip sold-out items
      // where currentVal is 0 - would produce a bogus 100% otherwise).
      if (compareVal > 0 && currentVal > 0 && compareVal > currentVal) {
        var pct = Math.round((compareVal - currentVal) / compareVal * 100);
        // Round UP to the nearest 5 when within 2 of it (29 ? 30, 28 ? 30).
        var nextFive = Math.ceil(pct / 5) * 5;
        if (nextFive - pct <= 2) pct = nextFive;
        saleEl.setAttribute('data-pct', pct);
      }
    }
  }

  function init() {
    setSavingsPct();
    var pending;
    var observer = new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(setSavingsPct, 200);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ================================================
   SIZE CHART SYSTEM TOGGLE (conversion charts, e.g. footwear US/UK/EU)
   Standard component: toggle buttons carry data-system; data cells carry data-col.
   Clicking a system makes it the PRIMARY (bold) column; the others mute.
   Reuses the .mrderk-size-chart shell + .msc-row layout. Added 2026-07-27.
   ================================================ */
(function () {
  function initSystemToggles() {
    var toggles = document.querySelectorAll('.mrderk-system-toggle');
    if (!toggles.length) return;
    for (var t = 0; t < toggles.length; t++) {
      (function (toggle) {
        if (toggle.getAttribute('data-bound') === '1') return;
        var chart = toggle.closest('.mrderk-size-chart');
        if (!chart) return;
        var btns = toggle.querySelectorAll('[data-system]');
        if (!btns.length) return;

        function setSystem(sys) {
          var cells = chart.querySelectorAll('[data-col]');
          for (var i = 0; i < cells.length; i++) {
            if (cells[i].getAttribute('data-col') === sys) {
              cells[i].classList.add('msc-col-active');
              cells[i].classList.remove('msc-col-muted');
            } else {
              cells[i].classList.remove('msc-col-active');
              cells[i].classList.add('msc-col-muted');
            }
          }
          for (var b = 0; b < btns.length; b++) {
            var on = btns[b].getAttribute('data-system') === sys;
            btns[b].style.background = on ? '#231F20' : '#FFFFFF';
            btns[b].style.color = on ? '#FFFFFF' : '#231F20';
          }
        }

        for (var b = 0; b < btns.length; b++) {
          (function (btn) {
            btn.addEventListener('click', function () {
              setSystem(btn.getAttribute('data-system'));
            });
          })(btns[b]);
        }

        setSystem(toggle.getAttribute('data-default') || btns[0].getAttribute('data-system'));
        toggle.setAttribute('data-bound', '1');
      })(toggles[t]);
    }
  }
  window.addEventListener('load', initSystemToggles);
  document.addEventListener('toggle', function (e) {
    if (e.target.tagName === 'DETAILS') { setTimeout(initSystemToggles, 50); }
  }, true);
})();